module.exports = __webpack_public_path__ + "static/media/PinehurstAcres.2.Bylaws.7e20cc01.pdf";